import {PROJECT_RECEIVE_AVAILABLE_PROJECTS, PROJECT_SELECT_PROJECT} from "../config/actions";

export function receiveAvailableProjects(availableProjects) {
    return {
        type: PROJECT_RECEIVE_AVAILABLE_PROJECTS,
        data: {
            availableProjects: availableProjects
        }
    }
}

export function selectProject(projectId) {
    window.setTimeout(function() {
        window.location.reload(true);
    }, 100);
    return {
        type: PROJECT_SELECT_PROJECT,
        data: {
            projectId: projectId
        }
    }
}